export { default } from "@casino/external/icons/SecurityPassport";
